import React from 'react';

import type { AnchoredNotificationProps, NotificationProps } from './Notification';
import { AnchoredNotification, Notification } from './Notification';

export type { AnchoredNotificationProps, NotificationProps };

export const AnchoredNotificationInfo = (props: AnchoredNotificationProps) => (
  <AnchoredNotification status="info" {...props} />
);

export const AnchoredNotificationAlert = (props: AnchoredNotificationProps) => (
  <AnchoredNotification status="alert" {...props} />
);

export const AnchoredNotificationWarning = (props: AnchoredNotificationProps) => (
  <AnchoredNotification status="warning" {...props} />
);

export const AnchoredNotificationSuccess = (props: AnchoredNotificationProps) => (
  <AnchoredNotification status="success" {...props} />
);

export const NotificationInfo = (props: NotificationProps) => (
  <Notification status="info" {...props} />
);

export const NotificationAlert = (props: NotificationProps) => (
  <Notification status="alert" {...props} />
);

export const NotificationWarning = (props: NotificationProps) => (
  <Notification status="warning" {...props} />
);

export const NotificationSuccess = (props: NotificationProps) => (
  <Notification status="success" {...props} />
);
